import { InfoOutlined } from '@mui/icons-material';
import { Stack, SxProps, Tooltip, Typography } from '@mui/material';
import { t } from 'i18next';

type Props = {
  blankText?: string;
  tooltip?: string;
  sx?: SxProps;
};

export const BlankCell = ({ blankText, tooltip, sx = {} }: Props) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ ...sx, overflow: 'hidden' }}>
      <Typography sx={{ color: 'text.secondary', fontStyle: 'italic', fontSize: 'inherit', overflow: 'hidden', textOverflow: 'ellipsis', pr: 0.25 }}>
        {blankText || t('noInformation')}
      </Typography>
      {!!tooltip && (
        <Tooltip title={tooltip}>
          <InfoOutlined sx={{ color: 'text.secondary' }} fontSize="small" />
        </Tooltip>
      )}
    </Stack>
  );
};
